export default {
  dashboard: {
    widget: {
      borderRadius: '4px',
      border: 'none',
      boxShadow: 'none',
    },
  },
}
